import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

const defaultDimension = 22;

const StyledCheckBox = styled.input<{
  $dimensions: number;
}>`
  height: ${({ $dimensions }) => $dimensions}px;
  width: ${({ $dimensions }) => $dimensions}px;
  cursor: pointer;
`;

type RegularFormProps = {
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

type UseFormProps = {
  name: string;
};

/** Type guard to assert whether form props passed are regular form props. */
const isRegularForm = (
  formProps: RegularFormProps | UseFormProps,
): formProps is RegularFormProps => {
  return (formProps as RegularFormProps).onChange !== undefined;
};

/**
 * A checkbox component that can be used in both regular and react-hook-form
 * contexts.
 */
export const Checkbox: FC<{
  formProps: RegularFormProps | UseFormProps;
  dimensions?: number;
  isDisabled?: boolean;
}> = ({ formProps, dimensions = defaultDimension, isDisabled = false }) => {
  const methods = useFormContext();

  return isRegularForm(formProps) ? (
    <StyledCheckBox
      type='checkbox'
      checked={formProps.checked}
      onChange={formProps.onChange}
      $dimensions={dimensions}
      disabled={isDisabled}
    />
  ) : (
    <StyledCheckBox
      type='checkbox'
      {...(methods ? methods.register(formProps.name) : {})}
      name={formProps.name}
      $dimensions={dimensions}
      disabled={isDisabled}
    />
  );
};
